import { Component, Input, OnInit, Output, EventEmitter, SimpleChanges} from '@angular/core';
import { ToastsManager } from 'ng2-toastr';

import { Consultant } from '../../../models/Consultant.model';
import { BorrowedNote } from '../../../models/BorrowedNote.model';
import { ConsultantService } from '../../../services/consultant.service';
import { DropdownItemFactory } from '../../../shared/factories/dropdown/dropdown-item.factory';
import { DropdownSettingsFactory } from '../../../shared/factories/dropdown/dropdown-settings.factory';
import { CommonHelper } from '../../../shared/helpers/CommonHelper';

@Component({
  selector: 'modal-borrowed-note',
  templateUrl: './modal-borrowed-note.html',
  styleUrls: ['./modal-borrowed-note.css']
})

export class ModalBorrowedNote implements OnInit {
    datePattern = /^(0[1-9]|1[0-9]|2[0-9]|3[01]).(0[1-9]|1[012]).[0-9]{4}$/i;
    mask = [/[0-3]/,/[0-9]/,'/',/[0-1]/,/[0-9]/,'/',/[0-9]/,/[0-9]/,/[0-9]/,/[0-9]/];

    @Input() consultantsBorrowInvoice;
    @Output() sendBorrowedNoteData: EventEmitter<any> = new EventEmitter();

    borrowedNote: BorrowedNote = new BorrowedNote();
    consultantAux: Consultant = new Consultant();
    lenderDropdown = {
        list: [],
        options: null,
        selected: []
    };

    constructor(
        private toastr: ToastsManager,
        private dropDownItemFactory: DropdownItemFactory,
        private dropDownSettingFactory: DropdownSettingsFactory,
        private consultantService: ConsultantService,
        private commonHelper: CommonHelper,
    ) {}

    ngOnInit() {
    };

    ngOnChanges(changes: SimpleChanges) {
        this.lenderDropdown.options = this.dropDownSettingFactory.build({text:'Emprestador', singleSelection:true, enableCheckAll:false, searchPlaceholderText: 'Buscar' });
        if(changes.consultantsBorrowInvoice.currentValue && changes.consultantsBorrowInvoice.currentValue.length > 0)
            this.lenderDropdown.list = this.dropDownItemFactory.build({source:this.consultantsBorrowInvoice});
    }

    verifyDate(date, field){
        if(!(new RegExp(this.datePattern).test(date))){
            this.toastr.warning(`Digite uma data válida.`,"Data inválida!");
            this.borrowedNote[`${field}`] = "";
        }
    }

    async changeLender() {
        if(this.lenderDropdown.selected.length > 0) {
            const lender = this.lenderDropdown.selected[0];
            this.consultantAux = await this.consultantService.getById(lender.id);
        } else {
            this.consultantAux = new Consultant();
        }
    }

    finalize() {
        this.borrowedNote.lenderId = this.consultantAux._id;
        this.borrowedNote.lenderName = this.consultantAux.name;
        const data = { ...this.borrowedNote };
        this.sendBorrowedNoteData.emit(data);
    }

    closeModal() {
        this.sendBorrowedNoteData.emit({});
    }
}



// WEBPACK FOOTER //
// ./src/app/views/consultants/modal-borrowed-note/modal-borrowed-note.ts